/**
 * Factory method for creating a Tuple instance.
 * @param args
 */
export const tuple = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};
//# sourceMappingURL=tuple.js.map